import { RootState } from 'types'
import { CardDismissalAction } from 'redux/actions'
import { CardDismissalActions } from 'redux/actions/cardDismissals'

export default function reduce(
  state: RootState['cardDismissals'] = [],
  { type, payload }: CardDismissalAction,
): RootState['cardDismissals'] {
  if (type === CardDismissalActions.SET_CARD_DISMISSALS) {
    return [...(payload.names || [])]
  }

  if (!payload?.name) {
    return state
  }

  if (type === CardDismissalActions.CREATE_CARD_DISMISSAL) {
    return [...state, payload.name]
  }

  return state
}
